import { ComponentWithPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import { AnimationReady } from '../../../../../../../../../baseComponents/DoubleTable/types'
import TitleAndWhiteBoxLayout from '../../../../../../../../../baseComponents/Layout/TitleAndWhiteBoxLayout'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import TableSellDeliveryNotePending from './TableSellDeliveryNotePending'

type SellDeliveryNotePendingProps = ComponentWithPermissions & AnimationReady & {}

const SellDeliveryNotePending: React.FC<SellDeliveryNotePendingProps> = ({ animationReady }) => {
    const {t} = useTwinTranslation()

    return (
        <TitleAndWhiteBoxLayout title={t('sellDeliveryNotePending', 'Albaranes pendientes')}>
            <TableSellDeliveryNotePending animationReady={animationReady} />
        </TitleAndWhiteBoxLayout>
    )
}

export default SellDeliveryNotePending